import { InlineSvg } from "@/components/ui/inline-svg";
import { cn } from "@/lib/utils";

/** Renders a stored raw-SVG icon inline (admin-authored, trusted). */
function OptionIcon({ svg }: { svg: string }) {
  return (
    <InlineSvg
      svg={svg}
      // self-center: the card is a flex-col items-start container — the icon is
      // centered horizontally (matching the goal-type tiles) while the
      // label/description below stay left-aligned.
      className="shrink-0 self-center [&_svg]:h-10 [&_svg]:w-10"
    />
  );
}

/** QP-180 — one selectable card in cards display mode. */
export function OptionCard({
  selected,
  disabled,
  label,
  description,
  iconSvg,
  onSelect,
}: {
  selected: boolean;
  disabled: boolean;
  label: string;
  description: string | null;
  iconSvg: string | null;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      onClick={onSelect}
      className={cn(
        "flex flex-col items-start gap-2 rounded-lg border p-4 text-left transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        selected
          ? "border-primary ring-1 ring-primary bg-primary/5 dark:bg-primary/15"
          : "hover:border-primary/50",
        disabled && "opacity-60 cursor-not-allowed",
      )}
    >
      {iconSvg && <OptionIcon svg={iconSvg} />}
      <span className="font-medium">{label}</span>
      {description && <span className="text-sm text-muted-foreground">{description}</span>}
    </button>
  );
}
